import type { IconProps } from "./icon-types";

/**
 * Download 공용 UI glyph.
 *
 * Lucide의 `LuDownload` geometry를 정적 SVG로 인라인 — c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const DownloadIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" x2="12" y1="15" y2="3" />
  </svg>
);
